import certificatesSlice, { certificatesAdapter } from "./certificateSlice";
import { createSelector } from "@reduxjs/toolkit";
import { findTheLastTestReport } from "../../helpers/productHelper";

export const selectCertificateSlice = (state) => state[ certificatesSlice.name ];

const certificateAdapterSelectors = certificatesAdapter.getSelectors(selectCertificateSlice);

export const selectAllCertificates = certificateAdapterSelectors.selectAll;

export const selectLastCertificatesByCompanyName = createSelector(
  selectAllCertificates,
  (productList) => {
    const result = [];
    productList.forEach((product) => {
      const companyName = product.company?.name || '';
      const productData = {
        ...product,
        lastRecord: findTheLastTestReport(product)
      };

      const foundCompany = result.find((company) => company.name === companyName);

      if (foundCompany) {
        foundCompany.productList.push(productData);
        return;
      }

      result.push({
        ...(product?.company || {}),
        name: companyName,
        productList: [productData],
      })
    });

    result.sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }
)